import React from "react"
import { Trans, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import QuickbooksIcon from "@/components/QuickbooksIcon"
import CapsuleMarkIcon from "@/components/CapsuleMarkIcon"

const QuickbooksUpsell = () => {
  const { t } = useTranslation()
  return (
    <div className="quickbooks-upsell raised raised--small mt-10 mb-10">
      <div className="row center-xs">
        <div className="col-xs-12">
          <div className="quickbooks-upsell__logos mb-8">
            <div className="quickbooks-upsell__logo-wrapper shadow-md">
              <QuickbooksIcon width="80" height="80" />
            </div>

            <svg
              className="quickbooks-upsell__logos-divider"
              width="12"
              height="12"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 1V15M1 8H15"
                stroke="#8691a5"
                strokeWidth="2"
                stroke-linecap="round"
              />
            </svg>

            <div className="quickbooks-upsell__logo-wrapper shadow-md">
              <CapsuleMarkIcon width="100" height="100" />
            </div>
          </div>

          <h4>{t("quickbooks.upsell.ready-to-start-trial")}</h4>

          <p>
            <Trans
              i18nKey="quickbooks.upsell.visit-marketplace"
              components={{
                QuickBooksLink: (
                  <a
                    className="text-link text-link--bare"
                    title="QuickBooks Marketplace"
                    href="https://quickbooks.intuit.com/app/apps/appdetails/capsule/en-us"
                    target="_blank"
                  />
                ),
              }}
            />
          </p>
        </div>
      </div>
    </div>
  )
}

export default QuickbooksUpsell
